import * as React from 'react'
import { default as EntityStepBarItem, EntityStepState } from './EntityStepBarItem'

interface IStep {
  name: string
  toFind: (pathname: string) => boolean
}

interface IRenderStepBar {
  steps: IStep[]
  pathname: string
  title: string
}

const StepBar = (props: IRenderStepBar) => {
  const currentStep = props.steps.findIndex(it => it.toFind(props.pathname))
  if (currentStep < 0) {
    console.error(`Current step wasn't find on ${props.pathname}`)
  }
  const stepBars = props.steps.map((it, i) => {
    const state =
      currentStep === i
        ? EntityStepState.CURRENT
        : currentStep > i
        ? EntityStepState.COMPLETED
        : EntityStepState.REGULAR
    return (
      <EntityStepBarItem key={i} index={i + 1} state={state}>
        {it.name}
      </EntityStepBarItem>
    )
  })
  return (
    <div className='w100'>
      <div className='form-title-header'>
        <div>
          <span className='h3'>{props.title}</span>
          <span className='ml2 h6 font-light-blue-grey'>{`Step ${currentStep + 1} of ${props.steps.length}`}</span>
        </div>
      </div>
      <div className='flex justify-start bg-white w100'>
        <div className='w100 flex flex-row justify-start nav-shadow'>{stepBars}</div>
      </div>
    </div>
  )
}
export default StepBar



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityStepBarV2.tsx